import React, { useEffect, useState } from 'react';
import { Box, InputAdornment, Popper, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CustomCalendarPicker from '../CustomWeekPicker/CustomCalendarPicker';
import { calendarTypes, responsiveSizeTimesheet } from '../../../utils/constants';
import BaseSwipeableDrawer from '../BaseSwipeableDrawer/BaseSwipeableDrawer';
import classes from './CustomDayPicker.module.scss';
import { useWindowSize } from '../../../utils/hooks';
import colors from '../../../scss/colors';
import zIndex from '@mui/material/styles/zIndex';

export default function CustomDayPicker({
  date,
  changeHandler,
  sx,
  dayFormat,
  sxAdornment = {},
  rerender = false,
  testId = '',
  isMonthYearPicker = false,
  minDate = dayjs('1950-01-01'),
  maxDate = dayjs()
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  const [newDate, setDate] = useState(date ? dayjs(date).toDate() : null);
  const size = useWindowSize();
  const id = open ? 'simple-popper' : undefined;

  const handleCalendar = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePicker = (dt) => {
    setAnchorEl(null);
    setDate(dt);
    changeHandler(dt);
  };

  useEffect(() => {
    if (rerender) {
      setDate(date);
    }
  }, [date]);

  return (
    <div className='p-relative z-[99999]'>
      <TextField
        id={testId}
        onClick={handleCalendar}
        value={dayjs(newDate).format(dayFormat)}
        sx={sx}
        data-testid= {testId}
        InputProps={{
          endAdornment: (
            <InputAdornment sx={sxAdornment} position="end">
              <CalendarMonthIcon />
            </InputAdornment>
          )
        }}
      />
      {size.width > responsiveSizeTimesheet
        ? open && (
            <Popper
              sx={{
                zIndex: 9999,
                padding: '16px',
                borderRadius: '20px',
                backgroundColor: colors.PAGE_BACKGROUND,
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
            >
              <Box sx={{ border: '20px', p: 0, zIndex: 9999 }}>
                <CustomCalendarPicker
                  userDate={date === t('dashboard.timesheets.filters.day') ? dayjs() : date}
                  setUserDate={handlePicker}
                  calendarType={calendarTypes.DAY}
                  minDate={minDate}
                  maxDate={maxDate}
                  sx={{
                    width: '100%',
                    padding: '15px',
                    zIndex: 9999,
                    position: 'relative',
                  }}
                  isMonthYearPicker={isMonthYearPicker}
                />
              </Box>
            </Popper>
          )
        : open && (
            <BaseSwipeableDrawer height="auto" isDivider closeHandler={() => setAnchorEl(false)}>
              <h5 className={classes.header}>{t('common.general.day')}</h5>
              <CustomCalendarPicker
                userDate={date === t('dashboard.timesheets.filters.day') ? dayjs() : date}
                setUserDate={handlePicker}
                calendarType={calendarTypes.DAY}
                minDate={minDate}
                maxDate={maxDate}
                sx={{
                  width: '100%',
                  padding: '15px',
                  zIndex: 9999,
                  position: 'relative',
                }}
                isMonthYearPicker={isMonthYearPicker}
              />
            </BaseSwipeableDrawer>
          )}
    </div>
  );
}